import { defineStore } from 'pinia';
import axios from 'axios';

// Payment Requests admin store (Feature 5). Server-side paginated + filterable.
export const usePaymentRequestStore = defineStore('paymentRequests', {
    state: () => ({
        requests: [],
        pagination: null,   // Laravel paginator meta
        loading: false,
        acting: false,
        filters: { status: '', student_id: '', per_page: 20 },
        pendingCount: 0,
    }),

    actions: {
        async fetchRequests(page = 1) {
            this.loading = true;
            try {
                const params = { page, per_page: this.filters.per_page };
                if (this.filters.status) params.status = this.filters.status;
                if (this.filters.student_id) params.student_id = this.filters.student_id;
                const { data } = await axios.get('/admin/payment-requests', { params });
                // data.data is the Laravel paginator object
                this.requests = data.data.data ?? [];
                this.pagination = data.data;
            } finally {
                this.loading = false;
            }
        },

        async fetchPendingCount() {
            const { data } = await axios.get('/admin/payment-requests', {
                params: { status: 'pending', per_page: 1 },
            });
            this.pendingCount = data.data.total ?? 0;
            return this.pendingCount;
        },

        async approve(id, note) {
            this.acting = true;
            try {
                const { data } = await axios.post(`/admin/payment-requests/${id}/approve`, { note });
                return data;
            } finally {
                this.acting = false;
            }
        },

        async reject(id, note) {
            this.acting = true;
            try {
                const { data } = await axios.post(`/admin/payment-requests/${id}/reject`, { note });
                return data;
            } finally {
                this.acting = false;
            }
        },

        async show(id) {
            const { data } = await axios.get(`/admin/payment-requests/${id}`);
            return data.data;
        },
    },
});
